import { getAccountId } from "../utilities/localStorage";

export const isNewPPMode = () => {
  var accountId = Number(getAccountId());
  return [1300].includes(accountId);
};

export const isAutoLogoutFeatureAvailable = () => {
  return ![5665].includes(Number(getAccountId()));
};
